export default __webpack_public_path__ + "static/media/sb-title-cn.d712a7b2.webp";